import useSWR from "swr"
import { useXHR, XHRInstance } from "@sembark-travel/xhr"

export type TAmenityType = "hotel" | "room"

// `key` is null for amenities typed in by users (not from the predefined list)
export type TAmenity = {
	key: string | null
	name: string
}

export type TAmenityCategory = {
	category: string
	amenities: TAmenity[]
}

export function amenitiesXHR(xhr: XHRInstance) {
	return {
		async getAmenities(type: TAmenityType): Promise<TAmenityCategory[]> {
			return xhr
				.get<{ data: TAmenityCategory[] }>("/amenities", { params: { type } })
				.then((resp) => resp.data.data)
		},
	}
}

export function useAmenities(type: TAmenityType) {
	const xhr = useXHR()
	const {
		data,
		mutate: revalidate,
		isValidating,
		error,
	} = useSWR(`/api/amenities?type=${type}`, () =>
		amenitiesXHR(xhr).getAmenities(type)
	)
	return {
		amenityCategories: data,
		fetchAmenities: revalidate,
		isFetching: !data && !error,
		isRefreshing: isValidating,
		error,
	}
}

// Predefined amenities are matched by key, the ones typed in by users by name
export function isSameAmenity(a: TAmenity, b: TAmenity) {
	return a.key !== null || b.key !== null ? a.key === b.key : a.name === b.name
}
